<template>
  <b-container fluid>
    <b-row class="row-sm" style="height: 100vh">
      <b-col class="login-right">
        <b-row class="reset">
          <b-col offset="2" cols="8">
            <router-link to="/login">
              <img
                class="back"
                src="./../assets/icons/arrow-left.svg"
                alt="Back"
              />
            </router-link>
            <div v-if="!status">
              <h4 style="font-weight: 700" class="pb-2 text-center">
                Reset Password
              </h4>
              <p
                style="color: var(--gray-400); font-size: 1.125rem"
                class="pb-3 text-center"
              >
                Enter the email associated with your account and we’ll send an
                email with instructions to reset you password
              </p>
              <div class="invalid-feedback d-block">
                {{ error }}
                <span class="text-success">{{ success }}</span>
              </div>
              <b-form @submit.prevent="submit">
                <div class="pb-3">
                  <label>Email</label>
                  <b-form-input
                    :class="{ 'is-invalid': $v.email.$error }"
                    type="email"
                    placeholder="Enter your email address"
                    v-model.trim="$v.email.$model"
                    trim
                  />
                  <div class="invalid-feedback">
                    {{ $v.email.$error ? "Please enter a valid email" : "" }}
                  </div>
                </div>
                <b-button
                  :disabled="user.loading || $v.email.$invalid"
                  type="submit"
                  block
                  variant="primary"
                  >{{
                    user.loading ? "Loading..." : "Send Instructions"
                  }}</b-button
                >
              </b-form>
            </div>
            <div class="text-center" v-else>
              <img src="./../assets/icons/email.svg" alt="" />
              <h4 style="font-weight: 700" class="mt-4 pb-2 text-center">
                Check Your Mail
              </h4>
              <p
                style="color: var(--gray-400); font-size: 1.125rem"
                class="pb-3 text-center"
              >
                We have sent password recovery instructions to your email
              </p>
              <router-link to="/login">
                <b-button block variant="primary">
                  Go Back to Login Page
                </b-button>
              </router-link>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";

export default {
  name: "ForgotPassword",
  data() {
    return {
      email: "",
      disabled: true,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  methods: {
    ...mapActions({
      forgotPassword: "user/forgotPassword",
    }),
    submit() {
      this.$store.state.user.error = null;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.forgotPassword({
          email: this.email,
        });
      }
    },
  },
  computed: mapState({
    user: (state) => state.user,
    error: (state) => state.user.error,
    success: (state) => state.user.success,
    status: (state) => state.user.status,
  }),
  destroyed() {
    this.$store.state.user.error = null;
    this.$store.state.user.success = null;
    this.$store.state.user.status = null;
  },
};
</script>

<style></style>
